import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GraphBatchService } from 'src/app/core/services/graph-history/graph-batch.service';

/**
 * Añade el header `X-Batch-Id` a toda petición saliente cuando hay un batch
 * activo en `GraphBatchService`. El backend usa ese header para agrupar
 * mutaciones en una única entrada padre del historial.
 *
 * Excluimos deliberadamente las llamadas al propio endpoint de historial y
 * al de finalize para evitar que se auto-etiqueten.
 */
@Injectable()
export class BatchIdInterceptor implements HttpInterceptor {

	constructor(private batchService: GraphBatchService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const batchId = this.batchService.currentBatchId;
		if (!batchId) return next.handle(req);

		// No contaminar las llamadas al propio historial.
		if (req.url.includes('/history')) return next.handle(req);

		const cloned = req.clone({ setHeaders: { 'X-Batch-Id': batchId } });
		return next.handle(cloned);
	}
}
